// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"1eee0543","159":"2fe6e880","453":"f33eef1c","726":"8949fc63"}[chunkId] + ".chunk.js";
};